export default [
  {
    label: "Node",
    name: "node",
    type: "select",
    required: true,
    options: ["Available", "Unavailable"],
  },
  {
    label: "Doctor ID",
    name: "doctorId",
    type: "text",
    required: true,
  },
  {
    label: "Name",
    name: "name",
    type: "text",
    required: true,
  },
  {
    label: "Fullname EN",
    name: "fullnameEn",
    type: "text",
  },
  {
    label: "Fullname TH",
    name: "fullnameTh",
    type: "text",
  },
  {
    label: "License Id",
    name: "licenseId",
    type: "text",
  },
  {
    label: "Designation",
    name: "designation",
    type: "text",
  },
  {
    label: "Doctor Type",
    name: "doctorType",
    type: "select",
    options: ["Sleep Physician", "Other"],
  },
  {
    label: "Token",
    name: "accessToken",
    type: "text",
  },
  {
    label: "Email",
    name: "email",
    type: "text",
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["Available", "Unavailable"],
  },
  {
    label: "Doctor Payment Source",
    name: "paymentSource",
    type: "radio",
    options: [
      { label: "BrainDynamics Pays Doctor" },
      { label: "Hospital Pays Doctor" },
    ],
  },

  //   {
  //   label: "Cash Rate (THB)",
  //   name: "cashRate",
  //   type: "text",
  // },
  //   {
  //   label: "Social Security Rate (THB)",
  //   name: "socialSecurityRate",
  //   type: "text",
  // },
  //   {
  //   label: "OPD Rate (THB)",
  //   name: "opdRate",
  //   type: "text",
  // },
  // ---- RATES: Section 1
  { type: "section", label: "Diagnosis Rate" },
  { label: "Cash (THB)", name: "diagnosisCashRate", type: "text" },
  {
    label: "Social Security (THB)",
    name: "diagnosisSocialSecurityRate",
    type: "text",
  },

  // ---- RATES: Section 2
  { type: "section", label: "Post-consult Rate" },
  {
    label: "Cash (THB)",
    name: "postConsultCashRate",
    type: "text",
  },
  {
    label: "Social Security (THB)",
    name: "postConsultSocialSecurityRate",
    type: "text",
  },

  // ---- RATES: Section 3
  { type: "section", label: "CPAP Follow-up Rate" },
  {
    label: "Cash (THB)",
    name: "cpapFollowupCashRate",
    type: "text",
  },
  {
    label: "Social Security (THB)",
    name: "cpapFollowupSocialSecurityRate",
    type: "text",
  },

  {
    label: "Note",
    name: "note",
    type: "textarea",
    // options: ["Available", "Unavailable"],
  },
];
